import { render } from "./examScoreCharts.vue?vue&type=template&id=2440e225&scoped=true"
import script from "./examScoreCharts.vue?vue&type=script&lang=js"
export * from "./examScoreCharts.vue?vue&type=script&lang=js"

import "./examScoreCharts.vue?vue&type=style&index=0&id=2440e225&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2440e225"]])

export default __exports__